module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetLow.84c7936.webp";